import React from 'react'

function Instructors() {
  return (
    <div>Instructors</div>
  )
}

export default Instructors